(function(w) {
    $("[data-acf-type=kg-commentaires] textarea").on('keyup change',function () {            
            var $this = $(this),
            $block = $this.siblings('.textarea-count'),
            message = $block.data('message').split('|'),
            currentLength = $this.val().replace(/\r\n/g, "\n").length,
            maxLength = $this.attr('maxlength'),
            lengthRemaining = maxLength - currentLength;

        if (lengthRemaining <= 0) {
            lengthRemaining = 0;
            $this.val($this.val().substr(0, maxLength));
        }

        if (lengthRemaining <= 1) {
            $block.html(message[0].replace('%s', lengthRemaining));
        } else {
            $block.html(message[1].replace('%s', lengthRemaining));
        }
    });

})(window);